import styles from './index.module.sass';

const LoginFrame = ({ children }) => {
  return (
    <form className={styles.dialog} onSubmit={e => e.preventDefault()}>
      {children}
    </form>
  );
};

export default LoginFrame;
